import React from "react";

import { containersStyles } from "./Styles";

const HeaderContainer = ({children}) => {
    const styles = containersStyles();
    return(
        <div className={styles.headerContainer}>
            {children}
        </div>
    )
}

export default HeaderContainer